import loadable from '@loadable/component';

export default loadable(() =>
  import(/* webpackChunkName: "NavBarBottom" */ './containers/NavBarBottom'),
);
